<template>
  <ui-card class="card-book" :class="classes">
    <div class="card-image">
      <ui-carousel
        full-width
        auto
        loop
        :delay="3000"
        v-if="book.cover.length >= 2"
      >
        <ui-image
          :key="img"
          v-for="img of book.cover"
          :src="img"
          cover
        ></ui-image>
      </ui-carousel>
      <ui-image
        v-if="book.cover.length < 2"
        :src="cover"
        cover
      >
      </ui-image>
      <span
        v-if="book.intro"
        class="card-intro-trigger"
        @click="showIntro = true"
        ><ui-icon name="More"></ui-icon
      ></span>
      <ui-slide-panel v-if="book.intro" :show="showIntro" direction="down">
        <ui-icon
          name="close"
          class="close-icon"
          @click.native="showIntro = false"
        ></ui-icon>
        <div class="card-intro-content">{{ book.intro }}</div>
      </ui-slide-panel>
    </div>
    <div class="card-title" @click="go">
      <ui-icon
        name="icon-lock"
        v-if="book.passwordProtection"
        :title="$t('passwordProtection')"
      ></ui-icon
      >{{ book.title }}
    </div>
    <ui-avatar
      :url="book.userInfo.avatar"
      :size="avatarSize"
      :username="book.userInfo.username"
    ></ui-avatar>
    <span class="card-label" v-if="book.sticky">{{ $t("pintop") }}</span>
    <favorite :book="book" class="card-favorite"></favorite>
  </ui-card>
</template>
<script>
import logo from "../../assets/logo.png";
import Favorite from "../Favorite.vue";
export default {
  name: "CardBook",
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      showIntro: false
    };
  },
  components: {
    Favorite
  },
  computed: {
    avatarSize() {
      if (this.book.cardStyle == "default" || !this.book.cardStyle) {
        return "sm";
      } else {
        return "";
      }
    },
    classes() {
      return [
        `card-book-style-${
          this.book.cardStyle ? this.book.cardStyle : "default"
        }`,
        this.book.cover && `card-book-with-cover`
      ];
    },
    keepSize() {
      return this.book.cover.length == 0;
    },
    createdDate() {
      return this.$d(new Date(this.book.created));
    },
    link() {
      return `@${this.book.userInfo.username}/${this.book.code}`;
    },
    cover() {
      return this.book.cover.length
        ? this.book.cover.length == 1
          ? this.book.cover[0]
          : this.book.cover
        : logo;
    }
  },
  methods: {
    go() {
      this.$router.push("/" + this.link);
    }
  }
};
</script>
